import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const googleWorkspaceWeb: PluginWebManifest = {
  orgSetupComponent: {
    componentPath: '@reflex/plugin-google-workspace/web/GoogleWorkspacePage',
    label: 'Connect a Google account and (optionally) enable Gmail push.',
  },
};
